import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { AgePipe } from './age.pipe';
import { CapitalizeFirstPipe } from './capitalize-first.pipe';
import { DidDatePassPipe } from './didDatePass.pipe';
import { FilterCallbackPipe } from './filterCallbackPure.pipe';
import { FirstLetterLowercasePipe } from './firstLetterLowercase.pipe';
import { FormControlPipe } from './formControl.pipe';
import { FormGroupPipe } from './formGroup.pipe';
import { GetJobNameByIndexPipe } from './get-job-name-by-index.pipe';
import { GetTextByValPipe } from './get-text-by-val.pipe';
import { GetTranslationPipe } from './getTranslation.pipe';
import { MonthYearPipe } from './month-year.pipe';

const PIPES = [
  AgePipe,
  CapitalizeFirstPipe,
  FormControlPipe,
  FormGroupPipe,
  FilterCallbackPipe,
  GetTextByValPipe,
  GetTranslationPipe,
  DidDatePassPipe,
  FirstLetterLowercasePipe,
  GetJobNameByIndexPipe,
  MonthYearPipe,
];

@NgModule({
  imports: [],
  declarations: [PIPES],
  exports: [PIPES],
  providers: [DatePipe],
})
export class SharedUtilsPipesModule {}
